import React, { Component } from "react";
import ReactDOM from 'react-dom';
import styled from "styled-components";

import Backdrop from "views/components/UI/Backdrop";
import { theme } from "theme"

interface IModalWrapperProps {
    width?: string | number;
    height?: string | number;
}

const ModalWrapper = styled.div<IModalWrapperProps>`
    position: fixed;
    left: calc(50%);
    top: calc(50%);
    transform: translateX(-50%) translateY(-50%);
    background: #FFFFFF;
    z-index: 13;
    max-height: 90%;
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    display: flex;
    flex-direction: column;
`;

const ModalHeader = styled.div`
    position: relative;
    height: 48px;
    background: ${theme.colors.themePrimary};
    color: #FFFFFF;
    font-size: 20px;
    line-height: 48px;
    vertical-align: center;
    padding-left: 24px;
    padding-right: 45px;
`;

const HeaderCross = styled.div`
    position: absolute;
    top: 24px;
    right: 10px;
    cursor: pointer;
    width: 25px;
    height: 25px;
    
    :before {
        content: "";
        position: absolute;
        display: block;
        width: 17px;
        height: 2px;
        transform: rotate(45deg);
        background: #FFFFFF;
    }
    
    :after  {
        content: "";
        position: absolute;
        display: block;
        width: 17px;
        height: 2px;
        transform: rotate(-45deg);
        background: #FFFFFF;
    }
`;
const ContentWrapper = styled.div`
    flex: 1;
    overflow: hidden;
    height: 300px;
`;

const HeaderCrossMobile = styled(HeaderCross as any)`
    :before {
        background: #767676;
    }

    :after  {
        background: #767676;
    }
`;

interface IProps {
    title: string;
    width?: string | number;
    height?: string | number;
    handleClose: () => void;
}

class Modal extends Component<IProps> {
    handleCloseOnButton = (event: any) => {
        if (event.code === "Escape") {
            this.props.handleClose();
        }
    };

    componentDidMount(): void {
        window.addEventListener('keydown', this.handleCloseOnButton)
    }

    componentWillUnmount(): void {
        window.removeEventListener('keydown', this.handleCloseOnButton)
    }

    render() {
        const { children, title, handleClose } = this.props;
        return ReactDOM.createPortal(
            <>
                <Backdrop onClick={handleClose} />
                <ModalWrapper width={this.props.width} height={this.props.height}>
                    {
                        //@ts-ignore
                        <ModalHeader style={typeof window.cordova !== "undefined" ? {
                            background: "none",
                            color: "#000000",
                            height: "auto",
                            lineHeight: "unset",
                            padding: "15px 20px",
                        } : {}
                        }>
                            {title}
                            {
                                //@ts-ignore
                                typeof window.cordova !== "undefined" ?
                                    <HeaderCrossMobile onClick={handleClose} /> :
                                    <HeaderCross onClick={handleClose} />
                            }
                        </ModalHeader>
                    }
                    <ContentWrapper>
                        {children}
                    </ContentWrapper>
                </ModalWrapper>
            </>,
            document.getElementById('root')!
        );
    }
}

export default Modal;